import { render, staticRenderFns } from "./UserOvertime.vue?vue&type=template&id=34f973da"
import script from "../../../scripts/partials/user/UserOvertime.js?vue&type=script&lang=js&external"
export * from "../../../scripts/partials/user/UserOvertime.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports